<template>
  <div>
    <div class="pa-1">
      <v-card>
        <v-card-title>{{ $t('Active Users by Date') }}</v-card-title>

        <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>
        <template v-if="activeuserbydateSeries">
          <apexchart
            ref="activeuserbydate"
            :key="chartKey"
            type="area"
            height="350"
            :options="activeuserbydate"
            :series="activeuserbydateSeries"
          ></apexchart>
        </template>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import { PAGE } from '@/constants/page.js'
import moment from 'moment'

import VueApexCharts from 'vue-apexcharts'

import DashboardGraphLoading from './../DashboardGraphLoading'

export default {
  components: {
    DashboardGraphLoading,
    apexchart: VueApexCharts
  },
  props: ['loading', 'selectedDate', 'filter', 'com7pageid', 'filterUser', 'filterTcpPage'],
  data: function () {
    return {
      activeuserbydateSeries: undefined,
      activeuserbydate: {
        chart: {
          height: 350,
          type: 'area'
        },
        stroke: {
          curve: 'smooth'
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%'
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'datetime'
        },
        yaxis: {
          title: {
            text: 'Users'
          },
          tickAmount: 1
        },
        tooltip: {
          x: {
            format: 'dd/MM/yy HH:mm'
          }
        }
      },
      chartKey: 0
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    }),
    isTcpMainPage() {
      return PAGE.TCP_MAIN_PAGE.includes(this.selectedBot.pageid)
    }
  },
  watch: {
    loading: function () {},
    selectedDate: {
      handler: function () {
        this.getActiveUserByDate()
      },
      deep: true
    },
    filter: function () {
      this.getActiveUserByDate()
    },
    filterUser: function () {
      this.getActiveUserByDate()
    },
    filterTcpPage: function () {
      this.getActiveUserByDate()
    }
  },
  mounted: function () {
    this.initData()
  },
  methods: {
    initData() {
      this.getActiveUserByDate()
    },
    getActiveUserByDate: function () {
      const vm = this
      let data = {
        pageid: vm.selectedBot.pageid,
        datefrom: moment(vm.selectedDate.start).format('YYYY-MM-DD'),
        dateto: moment(vm.selectedDate.end).format('YYYY-MM-DD')
      }

      if (vm.filter !== 'all') {
        Object.assign(data, { app: vm.filter })
      }

      if (vm.isTcpMainPage) {
        data.pageid = vm.filterTcpPage ? vm.filterTcpPage.page_id : vm.selectedBot.pageid
        Object.assign(data, {
          tcp_master_page_id: vm.selectedBot.pageid
        })
      }

      vm.$emit('onLoaded', { loading: true, data: null })
      let selectedApi = 'getDashboardActiveUserByDate'
      if (['ticket2', 'studio7'].includes(vm.$store.state.selectedBot.theme)) {
        selectedApi = 'getcom7pagereport_activeusers_bydate'
        data.pageid = vm.com7pageid ? vm.com7pageid : vm.$store.state.selectedBot.pageid
      }

      if (vm.selectedBot && vm.selectedBot.type === 'mtc') {
        if (vm.filterUser && vm.filterUser.value !== 'all') {
          Object.assign(data, { filter: vm.filterUser.value })
        }
      }

      api[selectedApi](data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$emit('onLoaded', { loading: false, data: null })
          return
        }
        let data = []
        let data2 = []
        let data3 = []

        let max = 0

        response.data.forEach((val) => {
          data.push([moment(val['date']).format(), parseInt(val['activeusers'])])
          data2.push([moment(val['date']).format(), parseInt(val['newusers'])])
          data3.push([
            moment(val['date']).format(),
            parseInt(val['activeusers']) - parseInt(val['newusers'])
          ])

          if (max < parseInt(val['activeusers'])) {
            max = parseInt(val['activeusers'])
          }

          if (max < parseInt(val['newusers'])) {
            max = parseInt(val['newusers'])
          }
        })

        vm.activeuserbydateSeries = [
          { name: vm.$t('active users'), data: data },
          { name: vm.$t('new users'), data: data2 },
          { name: vm.$t('existing users'), data: data3 }
        ]

        vm.$nextTick(function () {
          if (vm.$refs.activeuserbydate) {
            vm.$refs.activeuserbydate.updateOptions({
              yaxis: {
                max: max + 5
              }
            })
          }
          vm.$emit('onLoaded', { loading: false, data: vm.activeuserbydateSeries })
        })

        vm.chartKey++
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/active-user/ActiveUserByDate.vue